(() => {
  function extractTag(alt) {
    if (!alt) return "";
    return alt.split("|")[0].trim(); // podržava i "FLOWERS | nešto"
  }

  function getSelectedDezenValue(section) {
    const blocks = section.querySelectorAll(".product-form__input");

    // prvo traži opciju "Dezen"
    for (const block of blocks) {
      const legend = block.querySelector("legend");
      const title = (legend?.textContent || "").trim().toLowerCase();

      if (title.includes("dezen")) {
        const checked = block.querySelector('input[type="radio"]:checked');
        if (checked) return checked.value;

        const select = block.querySelector("select");
        if (select) return select.value;
      }
    }

    // fallback: zadnja opcija
    const last = blocks[blocks.length - 1];
    if (!last) return "";
    const checked = last.querySelector('input[type="radio"]:checked');
    if (checked) return checked.value;
    const select = last.querySelector("select");
    if (select) return select.value;
    return "";
  }

  function filterMedia(section) {
    const tag = getSelectedDezenValue(section);
    if (!tag) return;

    const mediaItems = section.querySelectorAll(".product__media-item[data-alt-tag]");
    const thumbs = section.querySelectorAll(".thumbnail-list__item[data-alt-tag]");

    let firstThumbButton = null;

    mediaItems.forEach((item) => {
      const itemTag = extractTag(item.getAttribute("data-alt-tag"));
      item.style.display = itemTag === tag ? "" : "none";
    });

    thumbs.forEach((li) => {
      const itemTag = extractTag(li.getAttribute("data-alt-tag"));
      const show = itemTag === tag;
      li.style.display = show ? "" : "none";
      if (show && !firstThumbButton) firstThumbButton = li.querySelector("button") || li;
    });

    // prebaci na prvu vidljivu sliku te varijante
    if (firstThumbButton?.click) firstThumbButton.click();
  }

  function init() {
    document.querySelectorAll('section[id^="MainProduct-"], .product').forEach((section) => {
      filterMedia(section);

      section.addEventListener("change", (e) => {
        if (!e.target.closest("form")) return;
        setTimeout(() => filterMedia(section), 50);
      });
    });
  }

  document.addEventListener("DOMContentLoaded", init);
})();
